<template>
  <div class="survey-summaries">
    <div class="row">
      <div class="col col-12">
        <button
          :class="{
            btn: true,
            'btn-primary': true,
            'loading': loading
          }"
          :disabled="loading"
          @click="requestNew"
        >{{ generating ? 'Generating' : 'Generate New Summary' }}</button>
      </div>
      <div class="col col-12 mt-3">
        <template v-if="files.length">
          <ul class="file-list">
            <li v-for="file in listFiles" :key="file.url">
              <a :href="file.url" download="Survey Summaries.xlsx">{{ file.filename }}</a>
            </li>
          </ul>
          <button
            v-if="files.length > shortListSize"
            class="btn btn-secondary"
            type="button"
            @click="showAll = !showAll"
          >
            <span>{{ showAll ? 'Show Less' : 'Show More' }}</span>
            <i
              :class="`fa fa-${showAll ? 'minus' : 'plus'}`"
              role="presentation"
            />
          </button>
        </template>
        <div v-else-if="loading" class="message loading">
          <p>Loading...</p>
        </div>
        <div v-else class="message no-files">
          <p>No survey summaries available.</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'survey-summaries',
  data() {
    return {
      files: [],
      generating: false,
      loading: false,
      shortListSize: 10,
      showAll: false
    }
  },
  computed: {
    listFiles() {
      return this.showAll ? this.files : this.files.slice(0, this.shortListSize)
    }
  },
  methods: {
    loadFiles() {
      this.loading = true;

      this.$http
        .get('/api/survey-summaries')
        .then(this.setFilesFromResponse)
        .catch(error => {
          alert('There was a problem fetching the surveys from the server. Please reload the page.');
          console.error(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    requestNew() {
      this.generating = true;
      this.loading = true;

      this.$http
        .get('/api/survey-summaries/generate')
        .then(response => {
          this.setFilesFromResponse(response);
          alert('New summary generated.');
        })
        .catch(error => {
          alert('There was a problem generating a new survey. Please reload the page.');
          console.error(error);
        })
        .finally(() => {
          this.generating = false;
          this.loading = false;
        });
    },
    setFilesFromResponse(response) {
      if(!response) {
        throw 'No response.';
      }

      if(!response.data) {
        throw 'No response data.';
      }

      this.files = response.data;
    }
  },
  mounted() {
    this.loadFiles();
  }
}
</script>
<style lang="scss">
.survey-summaries {
  .file-list {
    li {
      display: block;
      margin: 0;
      padding: 8px;

      &:nth-child(odd) {
        background-color: lightgray;
      }

      a {
        color: #111;
        text-decoration: none;
        transition: color .25s ease-in-out;

        &:hover {
          color: #666;
        }
      }
    }
  }
}
</style>